import {createSlatePlugin} from "platejs";
import {toNodeProps} from "./withNodeProps";

export const ScriptPlugin = createSlatePlugin( {
    key: "script",
    node: {
        isElement: true,
    },
    parsers: {
        html: {
            deserializer: {
                rules: [{
                    validNodeName: "SCRIPT"
                }],
                toNodeProps: (params) => {
                    const nodeProps = toNodeProps(params);
                    return {
                        ...nodeProps,
                        elementAttributes: {
                            ...nodeProps.elementAttributes,
                            dangerouslySetInnerHTML: {__html: params.element.innerHTML}
                        }
                    }
                }
            }
        }
    }
})
